import { render, staticRenderFns } from "./ReportContractSuspend.vue?vue&type=template&id=87042f3c"
import script from "./ReportContractSuspend.vue?vue&type=script&lang=js"
export * from "./ReportContractSuspend.vue?vue&type=script&lang=js"
import style0 from "./ReportContractSuspend.vue?vue&type=style&index=0&id=87042f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports